module.exports = __webpack_public_path__ + "static/media/YF40_6.b261fd13.jpg";